import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import {
  ApmErrorHandler,
  ApmService,
  SharedModule, sharedReducer,
} from '@dcs-workspace/shared';
import { BackOfficeCommonModule } from '@dcs-workspace/back-office/common';
import { AppRoutingModule } from './app-routing.module';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { routerReducer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { Router } from '@angular/router';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormlyModule } from '@ngx-formly/core';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    BackOfficeCommonModule,
    StoreModule.forRoot({
      router: routerReducer,
    }),
    EffectsModule.forRoot([]),
    StoreModule.forFeature('shared', sharedReducer),
    StoreDevtoolsModule.instrument(),
    StoreRouterConnectingModule.forRoot(),
    FormlyModule.forRoot({ extras: { lazyRender: true } }),
  ],
  providers: [
    {
      provide: ApmService,
      useClass: ApmService,
      deps: [Router],
    },
    {
      provide: ErrorHandler,
      useClass: ApmErrorHandler,
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
